import type { IActionsResolver, IAreActionsDisabled, IExtraData, IRowData } from "@patternfly/react-table";
import { createContext, type Dispatch, type SetStateAction, useContext } from "react";
import type { IColumn, ITableRow } from "./PFTableV2";

interface ITableContext {
	columns: IColumn[];
	rows: ITableRow[];
	totalItems: number;
	actionResolver?: IActionsResolver;
	areActionsDisabled: IAreActionsDisabled;
	currentPage: number;
	perPage: number;
	searchValue: string;
	setSearchValue: Dispatch<SetStateAction<string>>;
	setSelectedPage: Dispatch<SetStateAction<number>>;
	setPerPage: Dispatch<SetStateAction<number>>;
	selectionFilterValue: string;
	setSelectionFilter: Dispatch<SetStateAction<string>>;
	searchFunction?:
		| ((
				query: string,
				filterType?: string,
				filterValue?: string | number,
				setSelectedPage?: Dispatch<SetStateAction<number>>,
		  ) => void)
		| undefined;
	selectItemsFunction?:
		| ((
				filter: string,
				currentPage: number,
				setSelectedPage: Dispatch<SetStateAction<number>>,
				perPage: number,
		  ) => void)
		| undefined;
	disableBuiltInPagination?: boolean | undefined;
}

const intialTableContext: ITableContext = {
	columns: [],
	rows: [],
	totalItems: 0,
	actionResolver: (_rowData: IRowData, _extraData: IExtraData) => [],
	areActionsDisabled: (_rowData: IRowData, _extraData: IExtraData) => false,
	currentPage: 1,
	perPage: 10,
	selectionFilterValue: "",
	searchValue: "",
	setSearchValue: () => {},
	setSelectedPage: () => {},
	setPerPage: () => {},
	setSelectionFilter: () => {},
};

export const TableContext = createContext<ITableContext>(intialTableContext);

export function useTableContext() {
	const context = useContext(TableContext);
	if (context === undefined) {
		throw new Error(`Please provide`);
	}
	return context;
}

export const TableContextConsumer = TableContext.Consumer;
